import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Texts from './views/Texts.vue'

Vue.use(Router)

export default new Router({
	routes: [
		{
			path: '/',
			name: 'home',
			component: Home
    },
		{
			path: '/texts',
			name: 'texts',
			component: Texts
        },
	],
	mode: 'abstract',
	linkActiveClass: 'active'
})